import React from "react";

function PrintBlackIcon() {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.7711 5.625H15.625V3.125C15.625 2.95924 15.5592 2.80027 15.4419 2.68306C15.3247 2.56585 15.1658 2.5 15 2.5H5C4.83424 2.5 4.67527 2.56585 4.55806 2.68306C4.44085 2.80027 4.375 2.95924 4.375 3.125V5.625H3.22891C2.1375 5.625 1.25 6.46641 1.25 7.5V13.75C1.25 13.9158 1.31585 14.0747 1.43306 14.1919C1.55027 14.3092 1.70924 14.375 1.875 14.375H4.375V16.875C4.375 17.0408 4.44085 17.1997 4.55806 17.3169C4.67527 17.4342 4.83424 17.5 5 17.5H15C15.1658 17.5 15.3247 17.4342 15.4419 17.3169C15.5592 17.1997 15.625 17.0408 15.625 16.875V14.375H18.125C18.2908 14.375 18.4497 14.3092 18.5669 14.1919C18.6842 14.0747 18.75 13.9158 18.75 13.75V7.5C18.75 6.46641 17.8625 5.625 16.7711 5.625ZM5.625 3.75H14.375V5.625H5.625V3.75ZM14.375 16.25H5.625V12.5H14.375V16.25ZM17.5 13.125H15.625V11.875C15.625 11.7092 15.5592 11.5503 15.4419 11.4331C15.3247 11.3158 15.1658 11.25 15 11.25H5C4.83424 11.25 4.67527 11.3158 4.55806 11.4331C4.44085 11.5503 4.375 11.7092 4.375 11.875V13.125H2.5V7.5C2.5 7.15547 2.82734 6.875 3.22891 6.875H16.7711C17.1727 6.875 17.5 7.15547 17.5 7.5V13.125ZM15.625 9.0625C15.625 9.24792 15.57 9.42918 15.467 9.58335C15.364 9.73752 15.2176 9.85768 15.0463 9.92864C14.875 9.99959 14.6865 10.0182 14.5046 9.98199C14.3227 9.94581 14.1557 9.85652 14.0246 9.72541C13.8935 9.5943 13.8042 9.42725 13.768 9.2454C13.7318 9.06354 13.7504 8.87504 13.8214 8.70373C13.8923 8.53243 14.0125 8.38601 14.1667 8.283C14.3208 8.17998 14.5021 8.125 14.6875 8.125C14.9361 8.125 15.1746 8.22377 15.3504 8.39959C15.5262 8.5754 15.625 8.81386 15.625 9.0625Z"
          fill="#6E7781"
        />
      </svg>
    </>
  );
}

export default PrintBlackIcon;
